import colors from "../../../../../appConfig/colors";
import { makeStyles } from "@material-ui/core/styles";

const AssessmentDashboardStyle = makeStyles((theme) => ({
	button: {
		margin: "10px",
		backgroundColor: colors.primary,
		width: "100px",
		height: "40px",
		color: colors.white,
		textTransform: "none",
		"&:hover": {
			backgroundColor: colors.darkCrimsonRed,
		},
	},
	dialogContainer: {
		overflow: "auto",
		whiteSpace: "nowrap",
	},
	dialogTitle: {
		background: colors.primary,
		color: colors.white,
	},
	dialogContent: {
		backgroundColor: colors.darkCharcoal,
	},
	contentGrid: {
		gap: 8,
		backgroundColor: colors.darkCharcoal,
	},
	headerContainer: {
		height: "40px",
		border: `1.5px solid ${colors.softSilver}`,
		width: "100%",
		minWidth: "1000px",
		overflow: "hidden",
	},
	headerFlex: {
		display: "flex",
	},
	headerLeft: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		height: "40px",
		color: colors.lightSkyBlue,
		fontWeight: 700,
		paddingLeft: "5px",
	},
	headerCenter: {
		flex: 1,
		textAlign: "center",
		display: "flex",
		flexDirection: "column",
		fontWeight: 700,
		height: "40px",
		justifyContent: "center",
		color: colors.lightSkyBlue,
	},
	headerRight: {
		flex: 1,
		textAlign: "right",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		height: "40px",
		fontWeight: 700,
		color: colors.lightSkyBlue,
	},
	headerRightFlex: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-end",
	},
	scoreText: {
		color: colors.white,
		paddingLeft: "5px",
		fontWeight: 400,
	},
	table: {
		backgroundColor: colors.darkCharcoal,
		border: `1.5px solid ${colors.softSilver}`,
		width: "100%",
		minWidth: "1000px",
	},
	pillarsCell: {
		verticalAlign: "middle",
		fontWeight: 700,
		fontSize: "0.9em",
		color: colors.lightSkyBlue,
		border: `1px solid ${colors.softSilver}`,
		textAlign: "center",
		padding: "0px 0px 0px 5px",
		minWidth: "50px",
		width: "50px",
		cursor: "pointer",
	},
	pillarText: {
		fontWeight: "bold",
		fontSize: "1em",
	},
	categoryCell: {
		verticalAlign: "middle",
		fontWeight: 700,
		fontSize: "0.9em",
		color: colors.white,
		border: `1px solid ${colors.softSilver}`,
		padding: "0px 0px 0px 5px",
		minWidth: "150px",
		width: "150px",
		cursor: "pointer",
	},
	subcategoryCell: {
		padding: "0px 0px 0px 5px",
		fontWeight: 600,
		fontSize: "0.8em",
		minWidth: "150px",
		width: "160px",
		border: `1.5px solid ${colors.softSilver}`,
	},
	scoreBarCell: {
		padding: 0,
		width: "30%",
		border: `1.5px solid ${colors.softSilver}`,
	},
	tooltipContainer: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
	},
	tooltipLeft: {
		position: "relative",
		height: 24,
		background: "transparent",
		width: "50%",
	},
	tooltipCenter: {
		position: "relative",
		height: 24,
		background: "transparent",
	},
	tooltipRight: {
		position: "relative",
		height: 24,
		background: "transparent",
		width: "50%",
	},
	scaleRow: {
		padding: 0,
	},
	scaleCell: {
		padding: 0,
		border: `1.5px solid ${colors.darkCharcoal}`,
	},
	scaleCellSpan: {
		padding: 0,
		border: `1.5px solid ${colors.darkCharcoal}`,
	},
	scaleContainer: {
		display: "flex",
		width: "100%",
		fontSize: "10px",
		color: colors.white,
	},
	scaleInner: {
		display: "flex",
		justifyContent: "space-between",
		width: "100%",
		fontSize: "11px",
		color: colors.white,
	},
	dialogActions: {
		backgroundColor: colors.darkCharcoal,
		paddingLeft: 15,
		paddingRight: 15,
		paddingBottom: 8,
	},
	downloadButton: {
		color: colors.white,
		width: "120px !important",
		backgroundColor: `${colors.primary} !important`,
		"&:hover": {
			backgroundColor: `${colors.darkCrimsonRed} !important`,
		},
	},
	closeButton: {
		color: colors.white,
		backgroundColor: `${colors.primary} !important`,
		width: "120px",
		"&:hover": {
			backgroundColor: `${colors.darkCrimsonRed} !important`,
		},
	},
	mainHoverCell: {
		color: `${colors.lightSkyBlue} !important`,
		cursor: "pointer",
		"&:hover": {
			backgroundColor: `${colors.white} !important`,
			color: `${colors.black} !important`,
		},
	},
	subHoverCell: {
		color: `${colors.white} !important`,
		cursor: "pointer",
		"&:hover": {
			backgroundColor: `${colors.white} !important`,
			color: `${colors.black} !important`,
		},
	},
	pdfClone: {
		width: "1323px",
		minHeight: "794px",
		maxWidth: "none",
		position: "fixed",
		left: "-20000px",
		top: 0,
		transform: "none",
		opacity: 1,
		zIndex: -1,
	},
}));

export default AssessmentDashboardStyle;
